/**
 * InterviewModuleShell — Kariyer Online prototip shell
 *
 * Sidebar KALDIRILDI (2-commit refactor). Artik sadece centered content wrapper.
 * isFullScreen=true  => <>{children}</> (full-screen sayfalar dokunulmaz)
 * isFullScreen=false => dis sarmalayici + flex-column centered <main>
 *
 * Global Navbar bu shell'in disinda App.js tarafindan kontrol edilir.
 * Dashboard route'larda (interview hub, history, readiness-report, cv,
 * instructor-reviews, cv-reviews) normal global Navbar gorunur.
 */


import { useLanguage } from '../contexts/LanguageContext';

// ── Shell — wraps Kariyer Online modulu ──────────────────────────────────────
/**
 * Props:
 *   children     ReactNode  — ana icerik
 *   isFullScreen boolean    — true => sadece children (full-screen sayfalar)
 */
export default function InterviewModuleShell({ children, isFullScreen = false }) {
  // lang erisilebilir kalsin (gelecek dil-duyarli genislemeler icin)
  // eslint-disable-next-line no-unused-vars
  const { lang } = useLanguage();

  if (isFullScreen) {
    // Full-screen modda wrapper yok; children dogrudan render
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--interview-content-bg)' }}>
      {/* ── MAIN CONTENT ─────────────────────────────────────────────────── */}
      <main
        style={{
          flex: 1,
          minWidth: 0,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '0 16px',
        }}
        id="interview-module-main"
      >
        {children}
      </main>
    </div>
  );
}
